module.exports = __webpack_public_path__ + "static/media/receipts-grey.fa3d7f5c.svg";